import { z } from 'zod/v4';
// Platform role - admin or operator only (customers use Account)
export const AdminUserRoleSchema = z.enum([
    'admin',
    'operator',
]);
// Admin user status
export const AdminUserStatusSchema = z.enum([
    'active',
    'inactive',
    'suspended',
]);
// Admin user schema - platform operators/admins only
export const AdminUserSchema = z.object({
    id: z.string().uuid(),
    auth0Id: z.string(), // Links to Auth0 user
    email: z.string().email(),
    firstName: z.string(),
    lastName: z.string(),
    displayName: z.string().optional(),
    // Role and permissions
    role: AdminUserRoleSchema,
    // Office assignment
    officeId: z.string().uuid().optional(),
    officeName: z.string().optional(), // Denormalized for display
    // Contact
    phone: z.string().optional(),
    extension: z.string().optional(),
    // Work capacity
    maxWorkload: z.number().default(20),
    currentWorkload: z.number().default(0),
    // Shift information
    shiftStart: z.string().optional(), // e.g., "09:00"
    shiftEnd: z.string().optional(), // e.g., "17:00"
    timezone: z.string().default('America/Los_Angeles'),
    // Avatar/profile
    avatarUrl: z.string().url().optional(),
    // Notes
    notes: z.string().optional(),
    // Status
    status: AdminUserStatusSchema.default('active'),
    // Timestamps
    lastLoginAt: z.string().datetime().optional(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const CreateAdminUserSchema = AdminUserSchema.omit({
    id: true,
    currentWorkload: true,
    lastLoginAt: true,
    createdAt: true,
    updatedAt: true,
});
export const UpdateAdminUserSchema = AdminUserSchema.partial().omit({
    id: true,
    auth0Id: true,
    createdAt: true,
});
// Admin user preview for hover displays
export const AdminUserPreviewSchema = z.object({
    id: z.string().uuid(),
    email: z.string().email(),
    firstName: z.string(),
    lastName: z.string(),
    role: AdminUserRoleSchema,
    officeName: z.string().optional(),
    status: AdminUserStatusSchema,
    currentWorkload: z.number(),
    maxWorkload: z.number(),
});
